export const RankingPositive = () => {
  return (
    <svg fill="none" height="10" viewBox="0 0 14 10" width="14" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 5.00001L5.33357 8L12 2"
        stroke="#0F993D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
    </svg>
  );
};
